/* eslint-disable react-doctor/no-inline-exhaustive-style */
interface ModelBadgeProps {
  model: string;
  active?: boolean;
}

export function ModelBadge({ model, active = false }: ModelBadgeProps) {
  return (
    // eslint-disable-next-line react-doctor/no-inline-exhaustive-style
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 30,
        height: 30,
        padding: "0 6px",
        // §02.4/§17.2: badges never carry a radius above 0 — that's the
        // tell between a Pill (pressable, radius-pill) and a Badge (status
        // mark, radius-0).
        borderRadius: 0,
        background: active
          ? "color-mix(in srgb, var(--tls-fg-strong) 8%, transparent)"
          : "transparent",
        border: `1px solid ${
          active
            ? "color-mix(in srgb, var(--tls-fg-strong) 30%, transparent)"
            : "var(--tls-border-subtle)"
        }`,
        color: active ? "var(--tls-fg-strong)" : "var(--tls-fg-subtle)",
        fontFamily: "var(--tls-font-body)",
        // eslint-disable-next-line react-doctor/no-tiny-text
        // §15.2: REM category — 11px at the 16px reference root.
        fontSize: "0.6875rem",
        fontWeight: 600,
        letterSpacing: "0.04em",
      }}
    >
      {model}
    </span>
  );
}
